export const PaginationView = ({ props }) => {
  const pagination = props.pagination || {};  

  return (
    <el-pagination
      onSize-change={pagination.sizeChange}
      onCurrent-change={pagination.pageChange}
      current-page={pagination.current}
      page-size={pagination.size}
      page-sizes={pagination.pageSizes}
      layout="total, sizes, prev, pager, next, jumper"
      total={pagination.total}
      background
    />
  );
};